import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ScoreGauge, StatusBadge, NationBadge } from "@/components/Compliance";
import { ShieldCheck, Lock } from "lucide-react";

export default function ShareView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  const [pin, setPin] = useState("");
  const [needPin, setNeedPin] = useState(false);
  const load = (p) => api.get(`/share/${token}`, { params: p ? { pin: p } : {} }).then((r) => { setData(r.data); setNeedPin(false); }).catch((e) => { const s = e?.response?.status; if (s === 401 || s === 403) { setNeedPin(true); if (s === 403) setErr("wrongpin"); } else setErr(e?.response?.data?.detail || true); });
  useEffect(() => { load(); }, [token]); // eslint-disable-line
  if (needPin && !data) return (
    <div className="min-h-screen grid place-items-center p-6"><div className="bg-card border border-border rounded-2xl p-6 w-full max-w-sm text-center" data-testid="share-pin-gate">
      <p className="font-heading font-bold">This link is PIN-protected</p><p className="text-xs text-muted-foreground mt-1">Enter the PIN the landlord gave you.</p>
      <input data-testid="share-pin-input" value={pin} onChange={(e) => setPin(e.target.value)} inputMode="numeric" className="mt-3 w-full min-h-[44px] px-3 rounded-xl border border-input bg-card text-center tracking-widest" />
      {err === "wrongpin" && <p className="text-xs text-rose-600 mt-1">Incorrect PIN</p>}
      <button data-testid="share-pin-submit" onClick={() => load(pin)} className="mt-3 w-full min-h-[44px] rounded-xl bg-navy text-white font-semibold">Unlock</button>
    </div></div>);

  if (err && err !== "wrongpin") return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="share-invalid">{typeof err === "string" ? err : "This share link is invalid or has expired."}</div>;
  if (!data) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;

  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 flex items-center px-4 sm:px-6 bg-navy text-white justify-between">
        <div className="flex items-center gap-2 font-heading font-extrabold text-lg"><span className="grid place-items-center h-8 w-8 rounded-lg bg-emerald-brand"><ShieldCheck size={18} /></span> GetCerty</div>
        <span className="flex items-center gap-1.5 text-xs text-white/70"><Lock size={13} /> Read-only verification</span>
      </header>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="bg-card border border-border rounded-2xl p-6 flex flex-col sm:flex-row gap-6 items-start">
          <ScoreGauge score={data.score} />
          <div>
            <div className="flex items-center gap-2 mb-2"><NationBadge nation={data.property.nation} /><StatusBadge status={data.status} /></div>
            <h1 className="font-heading text-xl font-bold">{data.property.name}</h1>
            <p className="text-muted-foreground text-sm">{data.property.address}</p>
            <p className="text-xs text-muted-foreground mt-1 capitalize">{data.property.property_type === "hmo" ? "HMO" : "Single let"}</p>
          </div>
        </div>
        <h2 className="font-heading text-lg font-bold mt-6 mb-3">Compliance status</h2>
        <div className="space-y-2">
          {data.items.map((it, i) => (
            <div key={i} className="bg-card border border-border rounded-xl p-4 flex items-center gap-3">
              <div className="flex-1"><div className="font-semibold text-sm">{it.rule}</div><div className="text-xs text-muted-foreground">{it.expiry_date ? `Expires ${it.expiry_date}` : it.label}</div></div>
              <StatusBadge status={it.status} label={it.label} />
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-muted-foreground mt-8">Shared via GetCerty — compliance tracking for UK landlords. <Link to="/" className="text-emerald-brand">Learn more</Link></p>
      </div>
    </div>
  );
}
